export default __webpack_public_path__ + "static/media/aaron_glass.cb23d5f5.jpg";